import { render, staticRenderFns } from "./EuropeanChallengesPage.vue?vue&type=template&id=15233312&scoped=true"
import script from "./EuropeanChallengesPage.vue?vue&type=script&lang=js"
export * from "./EuropeanChallengesPage.vue?vue&type=script&lang=js"
import style0 from "./EuropeanChallengesPage.vue?vue&type=style&index=0&id=15233312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15233312",
  null
  
)

export default component.exports